import React, {useState} from "react";
import {
  AButton,
  AIcon,
  APageLoader,
  APanel,
  APanelBody,
  APanelFooter,
  ATab,
  ATabGroup
} from "@cisco-sbg-ui/magna-react";
import {capitalize} from "lodash-es";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {
  selectIncidentPlaybookLoading,
  selectIncidentPlaybookStages
} from "store/selectors";
import CloseIncidentButton from "./CloseIncidentButton";
import PlaybookStage from "./PlaybookStage";
import css from "./Playbook.module.scss";

export default function Playbook() {
  const {t} = useTranslation();
  const stages = useSelector(selectIncidentPlaybookStages);
  const isLoading = useSelector(selectIncidentPlaybookLoading);
  const [activeStage, setActiveStage] = useState(1);
  const nextStage = activeStage + 1;
  const previousStage = activeStage - 1;

  return (
    <APanel className="ml-0">
      {isLoading ? (
        <APageLoader className="d-block mx-auto my-10" /> //Spinner here per https://magnetic.cisco.com/0a43ab5cd/p/43b10f-progress-and-loading-indicators
      ) : (
        <>
          <APanelBody className="pa-0">
            <div className={css.wrapper}>
              <div className={css.sidebar}>
                <ATabGroup vertical>
                  {stages.map(({coa, tasks}, index) => {
                    const stepNumber = index + 1;
                    return (
                      <ATab
                        key={`step-${stepNumber}`}
                        tabKey={`step-${stepNumber}`}
                        className={css.phase}
                        selected={activeStage === stepNumber}
                        disabled={!tasks || tasks?.length === 0}
                        onClick={() => setActiveStage(stepNumber)}>
                        {coa.stage}
                      </ATab>
                    );
                  })}
                </ATabGroup>
              </div>
              <PlaybookStage {...{activeStage}} />
            </div>
          </APanelBody>
          <APanelFooter className={css.contentFooter}>
            <AButton
              medium
              secondary
              className="mr-2"
              disabled={activeStage === 1}
              onClick={() => activeStage > 1 && setActiveStage(previousStage)}>
              {t("misc.back")}
            </AButton>

            {activeStage < stages?.length ? (
              <AButton
                medium
                className={css.footerButton}
                onClick={() => setActiveStage(nextStage)}>
                {t("response.skipStep", {
                  name: capitalize(stages[activeStage]?.coa?.stage)
                })}
                <AIcon right>arrow-right</AIcon>
              </AButton>
            ) : (
              <CloseIncidentButton className={css.footerButton} />
            )}
          </APanelFooter>
        </>
      )}
    </APanel>
  );
}
